export const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return {
    day,
    month,
    year,
  };
};

export const formatSkillDate = (date: string) => {
  const [year, month, day] = date.split('-');
  const [formatedDay] = day.split('T');

  return `${formatedDay}/${month}/${year}`;
};
